import { LOCALE_NUMBER_FORMAT } from '@/utils/constants/common';

export const truncateString = (str, maxLength) => {
  if (!str || typeof str !== 'string') return '';
  return str.length > maxLength ? str.slice(0, maxLength) + '...' : str;
};

export const hashString = (str) => {
  let hash = 0n;
  for (let i = 0; i < str.length; i++) {
    const char = BigInt(str.charCodeAt(i));
    hash = (hash << 5n) - hash + char;
  }
  return hash;
};

// 0부터 range 사이의 값 반환
export const hashToIndex = (str, range = 5) => {
  if (str) {
    const hash = hashString(str);
    return Number(hash % BigInt(range));
  } else {
    return -1;
  }
};

export const isValidJson = (str) => {
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
};

export const formatNumberWithComma = (amount) => {
  if (typeof amount !== 'number' || isNaN(amount)) {
    return '0';
  }
  return amount.toLocaleString(LOCALE_NUMBER_FORMAT);
};
